import * as self from '@/utils/update_store_data'
import moment from 'moment'
import store from '@/store/store'
import { getAxiosObject } from '@/utils/library'

// 主関数
export const updateStoreData = async (updatedTableNames, serverUpdatedAt) => {
  if (!self.isValidToken()) {
    return 'token expired'
  }
  try {
    const updatableStores = updatedTableNames
      .map(tableName => {
        const storeName = toStoreName(tableName)
        const storeUpdatedAt = store.getters[`${storeName}/getUpdatedAt`]
        return {
          tableName: tableName,
          updatedAt: storeUpdatedAt
        }
      })
      .filter(values => {
        return values.updatedAt <= serverUpdatedAt
      })
    if (updatableStores.length > 0) {
      const axiosObject = getAxiosObject()
      const res = await axiosObject.post('/store-update', updatableStores)
      if (res.status === 200) {
        const recordsByTable = res.data.recordsByTable
        const notificationCountByTable = res.data.notificationCountByTable
        updatableStores.forEach(updatableStore => {
          const tableName = updatableStore.tableName
          const latestRecords = recordsByTable[tableName]
          if (latestRecords.length > 0) {
            const storeName = toStoreName(tableName)
            const latestCount = notificationCountByTable[tableName]
            const storeUpdatedAt = updatableStore.updatedAt
            self.setLatestData(tableName, storeName, latestRecords)
            self.setLatestCount(storeName, latestCount)
            self.setLatestUpdatedAt(storeName, storeUpdatedAt, latestRecords)
          }
        })
      }
      return 'succeeded'
    } else {
      return 'no update needed'
    }
  } catch (error) {
    return 'failed'
  }
}

export const isNotificationStore = storeName => {
  const notificationStores = [
    'notices',
    'receivedMails',
    'reservationRequests',
    'reservations'
  ]
  return notificationStores.includes(storeName)
}

export const isSingleDataStore = tableName => {
  const singleDataStores = [
    'clinics',
    'commonSettings',
    'displays',
    'mailSettings',
    'previousMails',
    'printSettings',
    'reservationSettings',
    'shiftSettings'
  ]
  return singleDataStores.includes(tableName)
}

export const isValidToken = () => {
  const tokenIssuingTime = moment(
    store.getters['auth/tokenIssuingTime'],
    'YYYYMMDDHHmmss'
  )
  const after2hourTime = tokenIssuingTime.add(
    process.env.VUE_APP_EXPIRE_IN,
    'h'
  )
  return !moment().isAfter(after2hourTime)
}

export const setLatestCount = (storeName, latestCount) => {
  if (isNotificationStore(storeName)) {
    store.dispatch(`${storeName}/setCount`, latestCount)
  }
}

export const setLatestData = (tableName, storeName, latestRecords) => {
  const latestData = isSingleDataStore(tableName)
    ? latestRecords[0]
    : latestRecords
  store.dispatch(`${storeName}/updateAfter`, latestData)
}

export const setLatestUpdatedAt = (
  storeName,
  storeUpdatedAt,
  latestRecords
) => {
  const latestUpdatedAt = latestRecords.reduce((latest, current) => {
    const updatedAt = moment(current.updatedAt).format('YYYYMMDDHHmmss')
    return latest < updatedAt ? updatedAt : latest
  }, storeUpdatedAt)
  store.dispatch(`${storeName}/setUpdatedAt`, latestUpdatedAt)
}

export const toStoreName = tableName => {
  return isSingleDataStore(tableName) ? tableName.slice(0, -1) : tableName
}
